import React from 'react';

import { IMAGE_FORMAT_OPTIONS } from '@vlabs/api-bindings/src/luna-client/constants';
import validate from '@vlabs/shared/validators';
import { Control, SettingsItemWrapper } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './SharedSubFormStyles.module.sass';

const commonStylesProps = {
  className: st.SettingItem,
  titleClassName: st.SettingItem__Title,
  contentClassName: st.SettingItem__Content,
};

export const TargetsOverviewSubForm = ({ fieldName, analytic }) => {
  const { t } = useTranslation();

  const createFullName = (name) => (fieldName ? `${fieldName}.${name}` : name);

  const { register, control, formState: { errors } } = useFormContext();
  const targetsField = useWatch({ name: createFullName('parameters.targets'), defaultValue: [] });
  const isTargetsOverviewActive = targetsField.includes('overview');
  const isImageFormatJPEG = useWatch({ name: createFullName('parameters.parameters.image_retain_policy.mimetype') })?.value === 'JPEG';

  return (
    <>
      <SettingsItemWrapper
        data-tooltip-content={t(`videoAnalytics:form.${analytic}.targets.overview.tooltip`)}
        title={t(`videoAnalytics:form.save_event_frame`)}
        {...commonStylesProps}
      >
        <Control.Checkbox
          id={createFullName('parameters.targets.overview')}
          label={t(`videoAnalytics:form.${isTargetsOverviewActive ? 'enabled' : 'disabled'}`)}
          value="overview"
          {...register(createFullName('parameters.targets'))}
        />
      </SettingsItemWrapper>

      <SettingsItemWrapper
        data-tooltip-content={!isTargetsOverviewActive ? t(`videoAnalytics:form.${analytic}.image_retain_policy.mimetype.tooltip`) : null}
        disabled={!isTargetsOverviewActive}
        title={t('videoAnalytics:form.image_retain_policy.mimetype.label')}
        {...commonStylesProps}
      >
        <Control.Select
          control={control}
          disabled={!isTargetsOverviewActive}
          isClearable
          name={createFullName('parameters.parameters.image_retain_policy.mimetype')}
          options={IMAGE_FORMAT_OPTIONS.raw}
        />
      </SettingsItemWrapper>

      <SettingsItemWrapper
        data-tooltip-content={!isImageFormatJPEG ? t('videoAnalytics:form.image_retain_policy.quality.tooltip') : null}
        disabled={!isTargetsOverviewActive || !isImageFormatJPEG}
        title={t('videoAnalytics:form.image_retain_policy.quality.label')}
        {...commonStylesProps}
      >
        <Control.Input
          {...register(createFullName('parameters.parameters.image_retain_policy.quality'), {
            min: validate.gte(0),
            max: validate.lte(1),
            validate: validate.number(),
          })}
          disabled={!isTargetsOverviewActive || !isImageFormatJPEG}
          errors={errors}
        />
      </SettingsItemWrapper>

      <SettingsItemWrapper
        data-tooltip-content={!isTargetsOverviewActive ? t(`videoAnalytics:form.${analytic}.image_retain_policy.max_size.tooltip`) : null}
        disabled={!isTargetsOverviewActive}
        title={t('videoAnalytics:form.image_retain_policy.max_size.label')}
        {...commonStylesProps}
      >
        <Control.Input
          {...register(createFullName('parameters.parameters.image_retain_policy.max_size'), {
            min: validate.gte(0),
            validate: validate.integer(),
          })}
          disabled={!isTargetsOverviewActive}
          errors={errors}
        />
      </SettingsItemWrapper>
    </>
  );
};
